import Vue from 'vue'

const state = {
  units: [],
  financialClassifiers: [],
  timelessTendersCategories: [
    { name: 'Վառելիք', value: 'fuel', iconPath: '/assets/landing/images/categories/fuel.svg' },
    { name: 'Գրենական պիտույքներ և գրասենյակային նյութեր', value: 'office_supplies', iconPath: '/assets/landing/images/categories/office_supplies.svg' },
    { name: 'Տնտեսական, սանհիգիենիկ և լվացքի միջոցներ', value: 'household', iconPath: '/assets/landing/images/categories/household.svg' },
    { name: 'Շինանյութեր', value: 'building_materials', iconPath: '/assets/landing/images/categories/building_materials.svg' },
    { name: 'Համակարգիչներ և պատճենահանող սարքավորումներ', value: 'computers', iconPath: '/assets/landing/images/categories/computers.svg' },
    { name: 'Էլեկտրատեխնիկա, ռադիոտեխնիկա և կենցաղային պարագաներ', value: 'electronics', iconPath: '/assets/landing/images/categories/electronics.svg' },
    { name: 'Տպագրվող ապրանքներ', value: 'printers', iconPath: '/assets/landing/images/categories/printers.svg' },
    { name: 'Դեղորայք և պատվաստանյութեր', value: 'medicine', iconPath: '/assets/landing/images/categories/medicine.svg' },
    { name: 'Բժշկական սարքավորումներ, գործիքներ և պարագաներ', value: 'medical_tools', iconPath: '/assets/landing/images/categories/medical_tools.svg' },
    { name: 'Քիմիական նյութեր', value: 'chemicals', iconPath: '/assets/landing/images/categories/chemicals.svg' },
    { name: 'Գրասենյակային և կենցաղային գույք և կահույք', value: 'furniture', iconPath: '/assets/landing/images/categories/furniture.svg' },
    { name: 'Հանդերձանք և անկողնային պարագաներ', value: 'clothing', iconPath: '/assets/landing/images/categories/clothing.svg' },
    { name: 'Ավտոմեքենաներ', value: 'car', iconPath: '/assets/landing/images/categories/car.svg' },
    { name: 'Ավտոպահեստամասեր', value: 'car_parts', iconPath: '/assets/landing/images/categories/car_parts.svg' },
    { name: 'Սարքեր և սարքավորումներ', value: 'devices_and_tools', iconPath: '/assets/landing/images/categories/devices_and_tools.svg' },
    { name: 'Այլ ապրանքներ', value: 'other', iconPath: '/assets/landing/images/categories/Icon4.svg' },
  ],
  classifiers: [],
  innerMenuIsClosed: JSON.parse(localStorage.getItem('innerMenuIsClosed')) !== null ?
    JSON.parse(localStorage.getItem('innerMenuIsClosed')) : false
}

const getters = {
  units: state => state.units,
  financialClassifiers: state => state.financialClassifiers,
  timelessTendersCategories: state => state.timelessTendersCategories,
  classifiers: state => state.classifiers,
  innerMenuIsClosed: state => state.innerMenuIsClosed
}

const actions = {
  getUnits({ commit }) {
    // eslint-disable-next-line no-undef
    return $client.get('units').then(response => {
      commit('setUnits', response.data.data)
    })
  },
  getClassifier({ commit }, cpvId) {
    // eslint-disable-next-line no-undef
    return $client.get(`classifier${cpvId}`)
  },
  getFinancialClassifiers({ commit }) {
    // eslint-disable-next-line no-undef
    return $client.get('financialClassifier').then(response => {
      commit('setFinancialClassifiers', response.data.data)
      return response
    })
  },
  getClassifiers({ commit }) {
    // eslint-disable-next-line no-undef
    return $client.get('classifier').then((response) => {
        commit('setClassifiers', response.data.data)
        return response
    })
  },
  closeInnerMenu({ commit, getters }) {
    const innerMenuStatus = true
    commit('setInnerMenuStatus', innerMenuStatus)
    localStorage.setItem('innerMenuIsClosed', JSON.stringify(innerMenuStatus))
  },
  toggleInnerMenu({ commit, getters }) {
    const innerMenuStatus = !getters.innerMenuIsClosed
    commit('setInnerMenuStatus', innerMenuStatus)
    localStorage.setItem('innerMenuIsClosed', JSON.stringify(innerMenuStatus))
  }
}

const mutations = {
  setUnits(state, units) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'units', _.clone(units))
  },
  setFinancialClassifiers(state, financialClassifiers) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'financialClassifiers', _.clone(financialClassifiers))
  },
  setClassifiers(state, classifiers) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'classifiers', _.clone(classifiers))
  },
  setInnerMenuStatus(state, status) {
    // eslint-disable-next-line no-undef
    Vue.set(state, 'innerMenuIsClosed', _.clone(status))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
